import React, { useState, useEffect } from "react";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader";
import { OrbitControls } from "@react-three/drei";
import * as THREE from "three"; // Import THREE library

import santa from "../assets/santa.glb";

const SantaScene = React.memo(() => {
  const [santaModel, setsantaModel] = useState();

  useEffect(() => {
    const santaLoader = new GLTFLoader();
    santaLoader.load(santa, (gltf) => {
      setsantaModel(gltf.scene);
      const animation = gltf.animations[0];
      const mixer = new THREE.AnimationMixer(gltf.scene);
      const action = mixer.clipAction(animation);
      action.play();
      const animate = () => {
        mixer.update(0.016); 
        requestAnimationFrame(animate);
      };

      animate();
    });
  }, []);

  if (!santaModel) {
    return null; 
  }

  return (
    <>
      <primitive
        object={santaModel}
        position={[1.9, 0.9, 1]}
        scale={[0.5, 0.5, 0.5]}
        rotation={[0, Math.PI / 1, 0]}
      />

      <OrbitControls
        enableDamping
        dampingFactor={0.25}
        target={[0, 1, 0]}
        enableZoom
        zoomSpeed={0.5}
        center={[0, 0, 0]}
      />
    </>
  );
});

export default SantaScene;
